import { FireIcon } from '@hugeicons/react'
import clsx from 'clsx'

import { PageHero } from '@/shared/ui/Layout'
import { RewardBadge } from '@/shared/ui/RewardBadge'
import type { MissionWithProgress } from '@/types/mission'

import {
  MISSION_HERO_BADGE,
  type MissionShowStatus
} from '../../constants/showStatus'

type MissionShowHeroProps = {
  mission: MissionWithProgress
  showStatus: MissionShowStatus
}

export const MissionShowHero = ({
  mission,
  showStatus
}: MissionShowHeroProps) => {
  const { name, point_reward, coin_reward } = mission
  const heroBadge = MISSION_HERO_BADGE[showStatus]

  return (
    <PageHero
      art="/missions/target.png"
      backgroundImage="/missions/hero-bg.jpg"
      artFit="contain"
      className="mb-0"
    >
      {/* `not_started`: sem badge de status — o `MissionStatusCard` logo
          abaixo já mostra "Não iniciada" + "Abre em", badge aqui repetiria
          e tomava espaço do título (MASTER §7 L10/L11). */}
      {showStatus !== 'not_started' && (
        <span
          className={clsx(
            'inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-1 text-caps font-bold uppercase tracking-wide',
            heroBadge.className
          )}
        >
          {showStatus === 'available' && (
            <FireIcon size={10} variant="solid" aria-hidden />
          )}
          {heroBadge.label}
        </span>
      )}

      <PageHero.Title>{name}</PageHero.Title>

      {((point_reward ?? 0) > 0 || (coin_reward ?? 0) > 0) && (
        <div className="flex flex-wrap items-center gap-4">
          {(point_reward ?? 0) > 0 && (
            <RewardBadge type="xp" value={point_reward!} variant="inline" />
          )}
          {(coin_reward ?? 0) > 0 && (
            <RewardBadge type="coins" value={coin_reward!} variant="inline" />
          )}
        </div>
      )}
    </PageHero>
  )
}
